import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {unlinkAuthEmailType} from "./__graphql-types__/index.ts";

export const UNLINK_EMAIL_MUTATION: GqlOperation<
    unlinkAuthEmailType["response"],
    unlinkAuthEmailType["variables"]
> = gqlOp(gql`
    mutation unlinkAuthEmail($authEmail: String!) {
        unlinkEmail(authEmail: $authEmail) {
            user {
                id
                authEmails
            }
            error {
                code
            }
        }
    }
`);
